import React from 'react'

function StudentreportComp() {
  return (
    <div className='instructorComponent'>
        StudentreportComp
    </div>
  )
}

export default StudentreportComp